webpackJsonp([35783957827783],{

/***/ 50:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(221);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(577);
	
	var _scrollParent = __webpack_require__(578);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(576);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(579);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(575);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports["react-xmasonry"]=t(require("react")):e["react-xmasonry"]=t(e.React)}(this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.XBlock=t.XMasonry=void 0;var i=n(3),o=r(i),a=n(4),s=r(a);t.XMasonry=o.default,t.XBlock=s.default,"undefined"!=typeof window&&(window.XMasonry=o.default,window.XBlock=s.default)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.debounce=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:45,n=0;return function(){0!==n&&clearTimeout(n),n=setTimeout(function(){n=0,e()},t)}},t.isServer=!("undefined"!=typeof document&&"undefined"!=typeof window)},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),c=function(e){return e&&e.__esModule?e:{default:e}}(u),d=n(2),h=0,p=!1,f=function e(){if(!d.isServer){if(!document.body)return void document.addEventListener("DOMContentLoaded",e);var t=document.createElement("div");t.style.overflow="scroll",t.style.height=t.style.width="200px",t.style.visibility="hidden",t.style.padding=t.style.margin=t.style.border=0,document.body.appendChild(t),h=t.offsetWidth-t.clientWidth||0,p=!0,document.body.removeChild(t)}},v=function(e){function t(e){i(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={blocks:{},containerHeight:0,columns:1,containerWidth:0},n.columns=n.state.columns,n.blocks=n.state.blocks,n.container=null,n.debouncedResize=(0,d.debounce)(n.updateContainerWidth.bind(n)),n.fixedHeight=0,n.containerWidth=n.state.containerWidth,n.update=n.updateInternal.bind(n),n.smartUpdate=0,p||f(),n.props.responsive&&!d.isServer&&window.addEventListener("resize",n.debouncedResize),!d.isServer&&n.props.updateOnFontLoad&&document.fonts&&document.fonts.addEventListener&&document.fonts.addEventListener("loadingdone",n.update),n}return a(t,e),l(t,[{key:"getBestFitColumn",value:function(e){for(var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=Math.min(e.length-t+1,this.props.maxColumns-t+1),r=0,i=1/0,o=0;o<n;++o){var a=Math.max.apply(null,e.slice(o,o+t));a<i&&(i=a,r=o)}return{col:r,height:i}}}]),l(t,[{key:"updateInternal",value:function(){return!this.updateContainerWidth()&&this.measureChildren()}},{key:"componentDidMount",value:function(){this.updateInternal()}},{key:"componentWillMount",value:function(){this.updateContainerWidth()}},{key:"componentWillUnmount",value:function(){d.isServer||window.removeEventListener("resize",this.debouncedResize),!d.isServer&&this.props.updateOnFontLoad&&document.fonts&&document.fonts.addEventListener&&document.fonts.removeEventListener("loadingdone",this.update),this.smartUpdate&&clearTimeout(this.smartUpdate)}},{key:"componentWillReceiveProps",value:function(e){if(c.default.Children.count(e.children)<c.default.Children.count(this.props.children)){var t=new Set,n={};c.default.Children.forEach(e.children,function(e,n){return t.add(null===e.key?n:e.key)}),c.default.Children.forEach(this.props.children,function(e,r){var i=null===e.key?r:e.key;t.has(i)||(n[i]={})}),this.recalculatePositions(null,n)}}},{key:"componentDidUpdate",value:function(){this.updateInternal()&&this.props.smartUpdate&&this.runSmartUpdate()}},{key:"runSmartUpdate",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:100;if(100===t&&this.smartUpdate)clearInterval(this.smartUpdate),this.smartUpdate=0;else if(this.smartUpdate)return;this.smartUpdate=setTimeout(function(){var n=!d.isServer&&void 0!==document.hidden&&document.hidden;if(n)var r=document.addEventListener("visibilitychange",function(){document.hidden||(document.removeEventListener("visibilitychange",r),e.runSmartUpdate(2*t))},!1);if(e.smartUpdate=0,e.updateInternal())return void e.runSmartUpdate();n||e.runSmartUpdate(2*t)},Math.min(t,this.props.smartUpdateCeil))}},{key:"getColumnsNumber",value:function(e){return Math.max(1,Math.round(e/this.props.targetBlockWidth))}},{key:"updateContainerWidth",value:function(){var e=d.isServer&&!this.container?this.props.width||999*this.props.targetBlockWidth:this.container?this.container.clientWidth:0;return e!==this.containerWidth&&e!==this.containerWidth+h&&(this.setState({columns:this.columns=this.getColumnsNumber(e),containerWidth:this.containerWidth=e,blocks:this.blocks={}}),!0)}},{key:"measureChildren",value:function(){if(!this.container)return!1;for(var e={},t=!1,n=0;n<this.container.children.length;n++){var r=this.container.children[n],i=r.hasAttribute("data-xkey"),o=r.getAttribute("data-key"),a=+r.getAttribute("data-width");(i||(this.blocks[o]||{}).height!==r.clientHeight||(this.blocks[o]||{}).width!==a)&&(e[o]={height:r.clientHeight},t||(t=!0))}return t&&this.recalculatePositions(e),t}},{key:"recalculatePositions",value:function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=void 0,r=[],i=0;i<this.columns;++i)r.push(0);for(var o in this.blocks)this.blocks.hasOwnProperty(o)&&void 0===this.blocks[o]&&(null===t&&(t={}),t[o]={});if(t){n={};for(var a in this.blocks)this.blocks.hasOwnProperty(a)&&!t.hasOwnProperty(a)&&(n[a]=this.blocks[a]);for(var l in e)e.hasOwnProperty(l)&&!t.hasOwnProperty(l)&&(n[l]=e[l])}else n=s({},this.blocks,e);for(var u=0;u<this.container.children.length;u++){var c=this.container.children[u],d=c.getAttribute("data-key");if(n.hasOwnProperty(d)&&(!t||!t.hasOwnProperty(d))){var h=+c.getAttribute("data-width")||1,p=this.getBestFitColumn(r,h),f=p.col,v=p.height,m=v+n[d].height;n[d].left=this.containerWidth*f/this.columns,n[d].top=v,n[d].width=Math.min(h,this.columns);for(var y=0;y<h;++y)r[f+y]=m}}if(this.props.center&&0===r[r.length-1]){for(var b=1;0===r[r.length-1-b];++b);var g=this.containerWidth*b/this.columns/2;for(var k in n)n.hasOwnProperty(k)&&(n[k].left+=g)}this.setState({blocks:this.blocks=n,containerHeight:Math.max.apply(null,r)})}},{key:"render",value:function(){var e=this,n={},i=0,o=0===this.containerWidth?[]:this.props.children||[],a=c.default.Children.map(o,function(t,r){var o=null===t.key?r:t.key,a=e.blocks[o];return a||++i,n[o]=null,a?c.default.cloneElement(t,{"data-key":o,key:o,style:{left:Math.floor(a.left),top:a.top},measured:!0,height:a.height,parent:e}):c.default.cloneElement(t,{"data-key":o,"data-xkey":o,key:o,style:{visibility:d.isServer?"visible":"hidden"},height:0,parent:e})});for(var l in this.blocks)this.blocks.hasOwnProperty(l)&&!n.hasOwnProperty(l)&&(this.blocks[l]=void 0);var u=a.length-i>0||0===a.length?this.fixedHeight=this.state.containerHeight:this.fixedHeight,h=this.props,p=(h.center,h.maxColumns,h.responsive,h.smartUpdate,h.smartUpdateCeil,h.targetBlockWidth,h.updateOnImagesLoad,h.updateOnFontLoad,h.className),f=h.style,v=r(h,["center","maxColumns","responsive","smartUpdate","smartUpdateCeil","targetBlockWidth","updateOnImagesLoad","updateOnFontLoad","className","style"]);return c.default.createElement("div",s({className:"xmasonry"+(d.isServer?" xmasonry-static":"")+(p?" "+p:""),style:s({},t.containerStyle,{height:d.isServer?void 0:u},f),ref:function(t){return e.container=t}},v),a)}}]),t}(c.default.Component);v.defaultProps={center:!0,maxColumns:d.isServer?3:1/0,responsive:!0,smartUpdate:!0,smartUpdateCeil:1/0,targetBlockWidth:300,updateOnFontLoad:!0,updateOnImagesLoad:!0},v.containerStyle={position:"relative"},t.default=v},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),c=function(e){return e&&e.__esModule?e:{default:e}}(u),d=n(2),h=function(e){function t(){var e,n,r,a;i(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=r=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.divElement=null,r.placed=!1,a=n,o(r,a)}return a(t,e),l(t,[{key:"componentDidUpdate",value:function(){var e=this;if(!this.placed&&this.props.parent&&!this.props["data-xkey"]){this.placed=!0;var t=this.props.parent;requestAnimationFrame(function(){if(e.divElement){var n=Array.prototype.slice.call(e.divElement.querySelectorAll("img"));n.length>0&&t.props.updateOnImagesLoad&&n.forEach(function(e){return!e.complete&&e.addEventListener("load",t.update)}),e.props.height!==e.divElement.clientHeight&&t.update()}})}}},{key:"render",value:function(){var e=this,n=this.props,i=n.width,o=(n.height,n.measured),a=(n.parent,n.style),l=r(n,["width","height","measured","parent","style"]),u=this.props.parent.columns,h=Math.min(i||1,u,this.props.parent.props.maxColumns);return a.width=Math.floor(h*this.props.parent.containerWidth/u),c.default.createElement("div",s({"data-width":h},l,{style:s({},a,t.defaultStyle),className:o?"xblock":d.isServer?"xblock xblock-static":"",ref:function(t){return e.divElement=t}}),this.props.children)}}]),t}(c.default.Component);h.defaultProps={width:1,measured:!1},h.defaultStyle={position:d.isServer?void 0:"absolute",boxSizing:"border-box"},t.default=h}])});

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  a {\n    text-decoration: none;\n  }\n    opacity = ", ";\n"], ["\n  a {\n    text-decoration: none;\n  }\n    opacity = ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactComponentQueries = __webpack_require__(9);
	
	var _reactComponentQueries2 = _interopRequireDefault(_reactComponentQueries);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(29);
	
	var _redux = __webpack_require__(11);
	
	var _reactLazyload = __webpack_require__(221);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _masonry = __webpack_require__(70);
	
	var _masonry2 = _interopRequireDefault(_masonry);
	
	var _projectThumbnail = __webpack_require__(258);
	
	var _projectThumbnail2 = _interopRequireDefault(_projectThumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var opacity = _ref.opacity;
	  return opacity;
	});
	
	var featureEveryNth = 5;
	var availableWidths = [100, 90, 80, 70];
	
	function rotateArray(arr, times) {
	  var t = times % arr.length;
	
	  if (arr.length === 0 || arr.length === 1) {
	    return arr;
	  }
	  if (t === 0) {
	    return arr;
	  }
	
	  var head = arr[0],
	      tail = arr.slice(1);
	
	  var rotated = tail.concat(head);
	
	  return rotateArray(rotated, t - 1);
	}
	var thumbnailWidthPattern = rotateArray((0, _lodash.chain)((0, _lodash.range)(featureEveryNth)).map(function (i) {
	  return availableWidths[i % availableWidths.length];
	}).map(function (w) {
	  return w + "%";
	}).value(), Math.floor(Math.random() * availableWidths.length));
	
	var withComponentQueries = (0, _reactComponentQueries2.default)(function (_ref2, _ref3) {
	  var width = _ref2.width;
	  var mobile = _ref3.theme.mobile;
	
	  var layoutProps = function mapWidthToLayoutProps() {
	    var dFault = {
	      label: null,
	      gridProps: {
	        gutter: width / 25 + "px"
	      }
	    };
	
	    if (mobile.isMobile) {
	      if (width > 1000) {
	        return _extends({}, dFault, {
	          label: {
	            f: 8,
	            mt: 5
	          }
	        });
	      }
	
	      if (width > 700) {
	        return _extends({}, dFault, {
	          label: {
	            f: 9,
	            mt: 6
	          }
	        });
	      }
	
	      if (width > 500) {
	        return _extends({}, dFault, {
	          label: {
	            f: 10,
	            mt: 6
	          }
	        });
	      }
	
	      return _extends({}, dFault, {
	        label: {
	          f: 11,
	          mt: 7
	        }
	      });
	    }
	
	    return dFault;
	  }();
	
	  return {
	    layoutProps: layoutProps
	  };
	});
	
	exports.default = (0, _redux.compose)(_styledComponents.withTheme, withComponentQueries)(function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  _class.prototype.render = function render() {
	    var _props = this.props,
	        focusedProject = _props.focusedProject,
	        onProjectFocus = _props.onProjectFocus,
	        onProjectBlur = _props.onProjectBlur,
	        layoutProps = _props.layoutProps,
	        projects = _props.projects;
	    var gridProps = layoutProps.gridProps;
	
	    var thumbnails = (0, _lodash.chain)(projects).sortBy(function (p) {
	      return p.updatedAt;
	    }).reverse().map(function (item, i) {
	      var thumbnailWidth = thumbnailWidthPattern[i % thumbnailWidthPattern.length];
	      var featured = (i + 1) % featureEveryNth === 0;
	      var project = item;
	      var focused = focusedProject ? focusedProject.id === project.id : true;
	      return {
	        key: i,
	        span: featured ? 2 : 1,
	        element: _react2.default.createElement(_projectThumbnail2.default, {
	          opacity: focused ? 1 : 0.5,
	          project: project,
	          w: featured ? "100%" : thumbnailWidth,
	          labelProps: layoutProps.label,
	          onMouseEnter: function onMouseEnter() {
	            return onProjectFocus(project);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return onProjectBlur(project);
	          },
	          onLoad: null
	        })
	      };
	    }).value();
	
	    var _partition = (0, _lodash.partition)(thumbnails, function (t) {
	      return t.key < featureEveryNth * 2;
	    }),
	        initialThumbnails = _partition[0],
	        lazyThumbnails = _partition[1];
	
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_masonry2.default, { gutter: gridProps.gutter, elements: initialThumbnails }),
	      _react2.default.createElement(
	        _reactLazyload2.default,
	        { offset: 100, once: true },
	        _react2.default.createElement(_masonry2.default, { gutter: gridProps.gutter, elements: lazyThumbnails })
	      )
	    );
	  };
	
	  return _class;
	}(_react2.default.Component));
	module.exports = exports["default"];

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  img {\n    width: ", ";\n  }\n"], ["\n  opacity: ", ";\n  img {\n    width: ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _image = __webpack_require__(20);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectThumb = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var opacity = _ref.opacity;
	  return opacity;
	}, function (_ref2) {
	  var w = _ref2.w;
	  return w;
	});
	
	var Label = (0, _styledComponents2.default)(_rebass.Label)(_templateObject2);
	
	exports.default = function (_ref3) {
	  var project = _ref3.project,
	      w = _ref3.w,
	      opacity = _ref3.opacity,
	      labelProps = _ref3.labelProps,
	      onMouseEnter = _ref3.onMouseEnter,
	      onMouseLeave = _ref3.onMouseLeave,
	      onLoad = _ref3.onLoad;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { key: project.slug, to: "/projecten/" + project.slug },
	    _react2.default.createElement(
	      _rebass.Flex,
	      { justify: "center", align: "center", column: true },
	      _react2.default.createElement(
	        _rebass.Box,
	        { w: w },
	        _react2.default.createElement(
	          ProjectThumb,
	          {
	            name: "projectThumb",
	            key: project.slug,
	            opacity: opacity
	          },
	          _react2.default.createElement(_image2.default, {
	            onLoad: onLoad,
	            file: project.bannerImage,
	            onMouseEnter: onMouseEnter,
	            onMouseLeave: onMouseLeave
	          })
	        )
	      ),
	      labelProps && _react2.default.createElement(
	        _rebass.Box,
	        null,
	        _react2.default.createElement(
	          Label,
	          { f: labelProps.f, mt: labelProps.mt },
	          project.title
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 2rem;\n  padding: ", ";\n"], ["\n  font-size: 2rem;\n  padding: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactXmasonry = __webpack_require__(166);
	
	var _reactComponentQueries = __webpack_require__(9);
	
	var _reactComponentQueries2 = _interopRequireDefault(_reactComponentQueries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Element = _styledComponents2.default.div(_templateObject2, function (_ref) {
	  var gutter = _ref.gutter;
	  return gutter;
	});
	
	var parseCssUnit = function parseCssUnit(str) {
	  var num = parseFloat(str, 10);
	  return [num, str.match(/[\d.\-+]*\s*(.*)/)[1] || ""];
	};
	
	var Masonry = (0, _reactComponentQueries2.default)({
	  queries: [function (_ref2, _ref3) {
	    var width = _ref2.width;
	    var _ref3$columns = _ref3.columns,
	        columns = _ref3$columns === undefined ? 2 : _ref3$columns;
	
	    return {
	      targetBlockWidth: width / columns
	    };
	  }],
	  config: {
	    refreshRate: 50
	  }
	})(function (_React$Component) {
	  _inherits(_class2, _React$Component);
	
	  function _class2() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      resizing: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (this.props.targetBlockWidth !== nextProps.targetBlockWidth) {
	      this.setState({
	        resizing: true
	      });
	      if (this.resizeDone) {
	        clearTimeout(this.resizeDone);
	      }
	      this.resizeDone = setTimeout(function () {
	        _this2.setState({
	          resizing: false
	        });
	      }, 500);
	    }
	  };
	
	  _class2.prototype.render = function render() {
	    var _this3 = this;
	
	    var resizing = this.state.resizing;
	
	    if (resizing) {
	      return _react2.default.createElement(Container, null);
	    }
	
	    var _props = this.props,
	        targetBlockWidth = _props.targetBlockWidth,
	        elements = _props.elements,
	        _props$gutter = _props.gutter,
	        gutterProp = _props$gutter === undefined ? "0px" : _props$gutter;
	
	    var _parseCssUnit = parseCssUnit(gutterProp),
	        val = _parseCssUnit[0],
	        unit = _parseCssUnit[1];
	
	    var gutter = [val / 2, unit].join("");
	    var blocks = elements.map(function (_ref4, i) {
	      var element = _ref4.element,
	          _ref4$span = _ref4.span,
	          span = _ref4$span === undefined ? 1 : _ref4$span;
	
	      return _react2.default.createElement(
	        _reactXmasonry.XBlock,
	        { key: i, width: span },
	        _react2.default.createElement(
	          Element,
	          { gutter: gutter },
	          element
	        )
	      );
	    });
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        _reactXmasonry.XMasonry,
	        {
	          center: false,
	          ref: function ref(x) {
	            _this3.x = x;
	          },
	          smartUpdate: true,
	          responsive: false,
	          targetBlockWidth: targetBlockWidth
	        },
	        blocks
	      )
	    );
	  };
	
	  return _class2;
	}(_react2.default.Component));
	
	exports.default = Masonry;
	module.exports = exports["default"];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _meta = __webpack_require__(55);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _overlay = __webpack_require__(34);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _feed = __webpack_require__(257);
	
	var _feed2 = _interopRequireDefault(_feed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      focusedProject: null
	    }, _this.focusProject = function (project) {
	      _this.setState({
	        focusedProject: project
	      });
	    }, _this.loseProjectFocus = function (project) {
	      setTimeout(function () {
	        if (_this.state.focusedProject && _this.state.focusedProject.id === project.id) {
	          _this.setState({
	            focusedProject: null
	          });
	        }
	      }, 200);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _class.prototype.render = function render() {
	    var _props$data = this.props.data,
	        allProject = _props$data.allProject,
	        globalSeo = _props$data.globalSeo;
	    var focusedProject = this.state.focusedProject;
	
	
	    var projects = allProject.edges.map(function (_ref) {
	      var node = _ref.node;
	      return node;
	    });
	
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_meta2.default, globalSeo),
	      _react2.default.createElement(_feed2.default, {
	        projects: projects,
	        onProjectFocus: this.focusProject,
	        onProjectBlur: this.loseProjectFocus,
	        focusedProject: this.state.focusedProject
	      }),
	      _react2.default.createElement(_overlay2.default, {
	        elements: [["RO"], [focusedProject ? focusedProject.title : "ARCHITECTEN"], ["&"], ["AD"]]
	      })
	    );
	  };
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a91a06873d90349cc97d.js